import { render } from "./CompaniesListEntry.vue?vue&type=template&id=391e2f1d&scoped=true&ts=true"
import script from "./CompaniesListEntry.vue?vue&type=script&lang=ts"
export * from "./CompaniesListEntry.vue?vue&type=script&lang=ts"

import "./CompaniesListEntry.vue?vue&type=style&index=0&id=391e2f1d&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391e2f1d"]])

export default __exports__